import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
  computed,
  signal,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AbbIconComponent } from '@components/abb-icon/abb-icon.component';
import { AbbModalComponent } from '@components/abb-modal/abb-modal.component';
import { MODAL_DATA, ModalData } from '@components/abb-modal/modal';
import { TPipe } from '@pipes/t.pipe';
import { createFileURL } from '@utils/download';

export type ReportModalData = {
  id: string;
  filename: string;
  contentType: string;
  size: number;
  content: string;
};

@Component({
  selector: 'app-report-modal',
  standalone: true,
  template: `
    <abb-modal #modalRef>
      <div
        class="block content-center w-[700px] min-h-full h-[625px] overflow-hidden"
      >
        @if(loadingError()) {
        <abb-icon
          [name]="'abb/warning-circle-2'"
          [externalSize]="'text-7xl'"
          class="justify-center text-abb-error"
        ></abb-icon>
        <div class="py-10 content-center text-center">
          {{ 'Error loading file. Please try again later.' | t }}
        </div>
        } @else if (isCsv()) {
        <div class="p-4 overflow-x-auto">
          <table
            class="table-auto border-collapse border border-gray-300 min-w-full text-sm"
          >
            <thead class="bg-gray-100">
              <tr>
                @for (col of csvContent()[0]; track col) {
                <th
                  class="border border-gray-300 px-2 py-1 text-left whitespace-nowrap"
                >
                  {{ col }}
                </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of csvContent().slice(1); track row) {
              <tr>
                @for (cell of row; track cell) {
                <td class="border border-gray-300 px-2 py-1 whitespace-nowrap">
                  {{ cell }}
                </td>
                }
              </tr>
              }
            </tbody>
          </table>
        </div>
        } @else {
        <div class="w-full h-full overflow-hidden">
          <object
            #documentRef
            class="w-full h-full"
            [data]="pdfData()"
            [type]="data.contentType"
          ></object>
        </div>
        }
      </div>
    </abb-modal>
  `,
  styles: ``,
  imports: [AbbModalComponent, AbbIconComponent, TPipe],
})
export class ReportModalComponent
  implements ModalData<ReportModalData>, OnInit
{
  @ViewChild('modalRef') modalRef: AbbModalComponent | undefined;
  @ViewChild('documentRef') documentRef: ElementRef<Document> | undefined;
  loadingError = signal<boolean>(false);
  pdfData = signal<SafeResourceUrl | undefined>(undefined);
  csvContent = signal<string[][]>([]);
  isCsv = computed(() => this.data.contentType.includes('csv'));
  constructor(
    @Inject(MODAL_DATA) public data: ReportModalData,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (this.data.content) {
      if (this.data.contentType.includes('csv')) {
        const decoded = atob(this.data.content);
        const rows = decoded
          .split('\n')
          .map((row) => row.trim())
          .filter((row) => row.length > 0)
          .map((row) => row.split(','));
        this.csvContent.set(rows);
        console.log(this.csvContent());
      } else {
        const url = this.sanitizer.bypassSecurityTrustResourceUrl(
          createFileURL({
            content: this.data.content,
            contentType: this.data.contentType,
          })
        );
        this.pdfData.set(url);
      }
    } else {
      this.loadingError.set(true);
    }
  }
}
